import { useState } from "react";
import { useSnapshot } from "valtio";
import TWButton from "../../../../components/TWButton";
import { editorState } from "../../../../utils/editor";

interface SelectEventProps {
  onEventSelected: (eventId: string) => void;
  selectedEvent: string | null;
}

const SelectEvent = ({ onEventSelected, selectedEvent }: SelectEventProps) => {
  const { eventSchedules } = useSnapshot(editorState);
  const [selectedEventType, setSelectedEventType] = useState<string | null>(
    selectedEvent
  );

  const events = eventSchedules
    .map((schedule) => schedule.eventType)
    .filter(Boolean);

  const handleNext = () => {
    if (selectedEventType) {
      // Find the actual event ID that matches the selected event type
      const selectedEventSchedule = eventSchedules.find(
        (schedule) => schedule.eventType === selectedEventType
      );
      if (selectedEventSchedule) {
        onEventSelected(selectedEventSchedule._id);
      }
    }
  };

  return (
    <div className="px-2 pb-6 flex flex-col h-[656px]">
      {/* Stage Progress */}
      <div className="flex justify-between mb-8 font-glacial font-normal text-xs leading-[123%] tracking-normal uppercase text-gray-400">
        <span className="text-gray-900">1. Select Event</span>
        <span>2. Select Guests</span>
        <span>3. Summary</span>
      </div>

      <div className="space-y-3 flex-1 ml-4">
        {events.length > 0 ? (
          events.map((event) => (
            <label key={event} className="flex items-center cursor-pointer h-5">
              <input
                type="radio"
                name="event"
                value={event}
                checked={selectedEventType === event}
                onChange={(e) => setSelectedEventType(e.target.value)}
                className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500 mr-3"
              />
              <span className="font-glacial font-normal text-sm leading-[123%] tracking-normal text-gray-700">
                {event}
              </span>
            </label>
          ))
        ) : (
          <div className="text-center py-8">
            <p className="font-glacial text-sm text-gray-600 mb-4">
              No events found. You need to create events first to generate
              access cards.
            </p>
            <p className="font-glacial text-xs text-gray-500">
              Go to your wedding schedule and create events to get started.
            </p>
          </div>
        )}
      </div>

      <div className="mb-6 mx-auto">
        <TWButton
          onClick={handleNext}
          variant="primary"
          size="lg"
          className="w-[227px] h-12"
          disabled={!selectedEventType || events.length === 0}
        >
          NEXT
        </TWButton>
      </div>
    </div>
  );
};

export default SelectEvent;
